import { z } from 'zod';
import { LooseAutocomplete } from '../helpers/type-helpers';

export const CatCodeEnum = z.string();
export type CatCode = LooseAutocomplete<'CARD' | 'DERM' | 'GASTRO' | 'MSK'>;
